<template>
  <v-row>
    <!-- alert screen in progress -->
    <v-col cols="12" class="pa-0 mt-6">
      <v-alert class="mb-3" text outlined color="secondary" rounded>
        <div class="d-flex pa-0">
          <v-icon color="secondary">mdi-pencil-ruler</v-icon>
          <div class="ml-5 alert-description-dash">
            <span class="body-1 font-weight-bold secondary--text">Pantalla en proceso</span>
            <span class="d-block body-2 secondary--text pb-1">
              <span class="font-weight-medium">Próximamente</span>, estaremos <span class="font-weight-medium">implementando un dashboard</span>. Estamos trabajando en ello para <span class="font-weight-medium">ofrecerte una mejor experiencia.</span>
            </span>
          </div>
        </div>
      </v-alert>
    </v-col>
    <!-- end alert screen in progress -->
    <v-col class="pa-0 mt-3">
      <v-img contain :src="require(`@/assets/skeleton-loaders/skeleton-loader-dash--${$vuetify.theme.dark ? 'dark' : 'light'}.svg`)" :style="`height: ${$vuetify.breakpoint.width > 1800 ? '1000px !important' : '100%'}`" />
    </v-col>
    <v-col class="px-0 pt-0 mt-4 d-none">
      <v-card class="mb-5" flat>
        <v-card-text class="pa-0">
          <v-tabs class="tab_dash-fc" v-model="tab" color="primary" grow height="65" slider-size="3">
            <v-tab class="tab_dash-fc subtitle-1 text-none font-weight-medium" active-class="primary--text" exact :ripple="false">
              <v-icon :color="tab === 0 ? 'primary' : 'secondary'" left>mdi-file-document-plus-outline</v-icon>
              Emisión de documentos
            </v-tab>
            <v-tab class="tab_dash-fc subtitle-1 text-none font-weight-medium" active-class="primary--text" exact :ripple="false">
              <v-icon :color="tab === 1 ? 'primary' : 'secondary'" left>mdi-file-document-check-outline</v-icon>
              Recepción de documentos
            </v-tab>
          </v-tabs>
          <v-divider />
          <v-col class="px-9 text-right">
            <!-- last day select -->
            <v-menu v-if="$store.state.auth.account.id" close-on-click close-on-content-click offset-y :nudge-bottom="8" left transition="slide-y-transition">
              <template v-slot:activator="{on, attrs}">
                <v-btn class="font-weight-regular body-1" v-on="on" v-bind="attrs" color="primary" :ripple="false">
                  <v-icon left>mdi-calendar-blank</v-icon>
                  Últimos 7 días
                  <v-icon size="18" right>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list class="pa-0">
                <v-list-item class="px-3" active-class="transparent" :ripple="false">
                  <v-list-item-title class="body-1"> Últimos 7 días</v-list-item-title>
                </v-list-item>
                <v-list-item class="px-3" active-class="transparent" :ripple="false">
                  <v-list-item-title class="body-1"> Últimos 15 días</v-list-item-title>
                </v-list-item>
                <v-list-item class="px-3" active-class="transparent" :ripple="false">
                  <v-list-item-title class="body-1"> Últimos 30 días</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- end last day select -->
          </v-col>
          <v-divider />
          <!-- documents status -->
          <v-row class="ma-0" align="center" no-gutters>
            <v-col cols="4" class="py-5 pl-10">
              <v-sheet class="py-0 transparent">
                <v-col class="py-0">
                  <span class="d-block secondary--text subtitle-2 font-weight-bold">Total de documentos {{tab === 0 ? 'emitidos' : 'recibidos'}}</span>
                  <span class="d-block text-h2 secondary--text font-weight-bold">{{tab !== 0 ? '14.909' : '28.909'}}</span>
                  <span class="mt-n2 d-block text-h5 secondary--text font-weight-medium">{{tab !== 0 ? '15.714' : '25.714'}}</span>
                  <div class="mt-n2 d-flex align-center">
                    <span :class="`${tab === 0 ? 'success' : 'error'}--text subtitle-2`">{{tab !== 0 ? '-2.4%' : '+12.34%'}}</span>
                    <v-icon size="32" :color="tab === 0 ? 'success' : 'error'">{{ `mdi-menu-${tab === 0 ? 'up' : 'down'}`}}</v-icon>
                    <span class="body-1 secondary--text">vs 7 días anteriores</span>
                  </div>
                </v-col>
              </v-sheet>
            </v-col>
            <v-divider vertical />
            <v-col cols="7" class="mx-auto text-center pa-5 pb-4">
              <div class="d-flex mb-10 mt-1 pl-3 secondary--text">
                <div class="text-left mr-16">
                  <v-avatar class="body-2 mr-3" size="12" color="#0F52A0" />Anterior
                </div>
                <div class="text-left">
                  <v-avatar class="body-2 mr-3" size="12" color="#52657D" />Actual
                </div>
              </div>
              <chart-line
                class="d-block mt-n8"
                :key="tab"
                axe-type-y="number"
                :background-color="'transparent'"
                :colors="['#223AF8']"
                :chart-data="tab === 0 ? issueChartData : receivedChartData"
                :chart-id="'settings.i--1' || `${'metric'}_graph`"
                :customLabels="['Anterior', 'Actual']"
                :height="230"
                :number-rounded="true"
                :show-axe-x="true"
                :show-draw-border-grid-lines-axe-y="true"
                :show-grid-lines-axe-y="true"
                :show-point="true"
                :showLegend="false"
                :showAxeY="true"
                style="position:relative;"
              />
            </v-col>
          </v-row>
          <!-- end documents status -->

          <!-- documents issued by state -->
          <v-divider />
          <v-col cols="12" class="pt-9 px-9 text-center">
            <span class="secondary--text subtitle-2 font-weight-bold">Documentos emitidos por estado</span>
          </v-col>
          <v-row class="pb-8" no-gutters>
            <v-col>
              <v-sheet class="pt-3 text-center transparent">
                <v-icon class="d-block" color="success">mdi-check-circle-outline</v-icon>
                <v-progress-circular class="mb-5 mt-7" v-if=" loaderReport" indeterminate color="primary" :width="2" :size="24" />
                <span class="d-block text-h5 secondary--text font-weight-regular my-1" v-else>4.873</span>
                <v-sheet class="d-block body-2" height="30">Envío procesado</v-sheet>
                <v-btn :to="{name: 'DocumentsList', query: {status: 'EPR'}}" class="mt-n1 body-2" color="primary" text small :ripple="false">Ver documentos</v-btn>
              </v-sheet>
            </v-col>
            <v-col>
              <v-sheet class="pt-3 text-center transparent">
                <v-icon class="d-block" color="error">mdi-close-circle-outline</v-icon>
                <v-progress-circular class="mb-5 mt-7" v-if="loaderReport" indeterminate color="primary" :width="2" :size="24" />
                <span class="d-block text-h5 secondary--text font-weight-regular my-1" v-else>3</span>
                <v-sheet class="d-block body-2" height="30">Envío procesado</v-sheet>
                <v-btn :to="{name: 'DocumentsList', query: {status: 'PDR'}}" class="mt-n1 body-2" color="primary" text small :ripple="false">Ver documentos</v-btn>
              </v-sheet>
            </v-col>
            <v-col>
              <v-sheet class="pt-3 text-center transparent">
                <v-icon class="d-block" color="success">mdi-check-circle-outline</v-icon>
                <v-progress-circular class="mb-5 mt-7" v-if="loaderReport" indeterminate color="primary" :width="2" :size="24" />
                <span class="d-block text-h5 secondary--text font-weight-regular my-1" v-else>19</span>
                <v-sheet class="d-block body-2" height="30">Envío procesado</v-sheet>
                <v-btn :to="{name: 'DocumentsList', query: {status: 'EPR'}}" class="mt-n1 body-2" color="primary" text small :ripple="false">Ver documentos</v-btn>
              </v-sheet>
            </v-col>
            <!-- tab 2 -->
            <template v-if="tab === 1">
              <v-col>
                <v-sheet class="pt-3 text-center transparent">
                  <v-icon class="d-block" color="error">mdi-close-circle-outline</v-icon>
                  <v-progress-circular class="mb-5 mt-7" v-if="loaderReport" indeterminate color="primary" :width="2" :size="24" />
                  <span class="d-block text-h5 secondary--text font-weight-regular my-1" v-else>3</span>
                  <v-sheet class="d-block body-2" height="30">Rechazado por Error en Schema</v-sheet>
                  <v-btn :to="{name: 'DocumentsList', query: {status: 'RSC'}}" class="mt-n1 body-2" color="primary" text small :ripple="false">Ver documentos</v-btn>
                </v-sheet>
              </v-col>
              <v-col>
                <v-sheet class="pt-3 text-center transparent">
                  <v-icon class="d-block" color="success">mdi-check-circle-outline</v-icon>
                  <v-progress-circular class="mb-5 mt-7" v-if="loaderReport" indeterminate color="primary" :width="2" :size="24" />
                  <span class="d-block text-h5 secondary--text font-weight-regular my-1" v-else>19</span>
                  <v-sheet class="d-block body-2" height="30">Envío procesado</v-sheet>
                  <v-btn :to="{name: 'DocumentsList', query: {status: 'EPR'}}" class="mt-n1 body-2" color="primary" text small :ripple="false">Ver documentos</v-btn>
                </v-sheet>
              </v-col>
              <v-col>
                <v-sheet class="pt-3 text-center transparent">
                  <v-icon class="d-block" color="error">mdi-close-circle-outline</v-icon>
                  <v-progress-circular class="mb-5 mt-7" v-if="loaderReport" indeterminate color="primary" :width="2" :size="24" />
                  <span class="d-block text-h5 secondary--text font-weight-regular my-1" v-else>3</span>
                  <v-sheet class="d-block body-2" height="30">Envío procesado</v-sheet>
                  <v-btn :to="{name: 'DocumentsList', query: {status: 'PDR'}}" class="mt-n1 body-2" color="primary" text small :ripple="false">Ver documentos</v-btn>
                </v-sheet>
              </v-col>
            </template>
            <!-- end tab 2-->
          </v-row>
          <!-- end documents issued by state -->
        </v-card-text>
      </v-card>
    </v-col>

    <!-- help
    <v-col cols="12" class="mt-0 pt-0 pl-0">
      <v-toolbar class="mb-2" color="transparent" flat height="32">
        <v-toolbar-title class="secondary--text body-1 font-weight-bold">
          <v-icon size="20" color="secondary">mdi-help-circle-outline</v-icon>
          Centro de ayuda
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="ml-4" />
    </v-col>
    <v-row class="mx-1 mb-5">
      <v-col cols="9" class="pt-0">
        <v-row>
          <v-col cols="3" class="py-0" v-for="item in 4" :key="item">
            <v-sheet class="mt-8" outlined rounded>
              <v-list-item class="dashboardfx" three-line @click="intercomNewMessage('Hola, necesito ayuda para iniciar con Factura Chile')" target="_blank" link :ripple="false">
                <v-list-item-avatar class="mt-6">
                  <v-icon color="secondary" size="30">mdi-receipt-text-plus-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>Lorem ipsum dolor sit amet adipiscing</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" class="py-0">
        <v-sheet class="mt-5" outlined rounded>
          <v-list-item class="dashboardfx" three-line @click="intercomNewMessage('Hola, necesito ayuda para iniciar con Factura Chile')" target="_blank" link :ripple="false">
            <v-list-item-icon class="mt-7 mr-6 ml-1">
              <v-icon color="primary" size="45">mdi-forum</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="mb-n3 subtitle-1 font-weight-medium">¿Necesitas asistencia?</v-list-item-title>
              <v-list-item-subtitle class="">Inicia una conversación ahora.</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col>
    </v-row>
    <! end help -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
import ChartBarStacked from '@/components/charts/ChartBarStacked'
import ChartLine from '@/components/charts/ChartLine'

export default {
  components: {
    ChartLine,
    ChartBarStacked,
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    tab: 0,
    // example
    issueChartData: {
      labels: [
        "Lun",
        "Mar",
        "Mie",
        "Jue",
        "Vie",
        "Sab",
        "Dom"
      ],
      datasets: [
        {
          label: "Anterior",
          backgroundColor: '#0F52A0',
          percent_change: '2.34',
          data: [80, 39, 40, 40, 39, 80, 100]
        },
        {
          label: "Actual",
          backgroundColor: '#52657D',
          percent_change: '12.34',
          data: [60, 55, 32, 10, 16, 12, 53]
        }
      ]
    },
    receivedChartData: {
      labels: [
        "Lun",
        "Mar",
        "Mie",
        "Jue",
        "Vie",
        "Sab",
        "Dom"
      ],
      datasets: [
        {
          label: "Anterior",
          backgroundColor: '#0F52A0',
          data: [0, 33, 56, 20, 80, 50, 0]
        },
        {
          label: "Actual",
          backgroundColor: '#52657D',
          data: [0, 5, 52, 9, 1, 3, 5]
        }
      ]
    },
    // end expample
    headers: [
      { text: 'Estado de respuesta', value: 'code', class: 'font-weight-bold', sortable: true },
      { text: 'Documento', value: 'document' },
      { text: '', value: 'status' },
      { text: 'Fecha', value: 'date', align: 'end', sortable: true },
      { text: 'Total', value: 'total', align: 'end', sortable: true }
    ],
    loaderList: false,
    loaderReport: false,
    statusesAcknowledgment: [
      {
        code: 'RCD',
        name: 'Reclamación por el contenido del documento'
      },
      {
        code: 'RFP',
        name: 'Reclamación por falta parcial de productos'
      },
      {
        code: 'RFT',
        name: 'Reclamación por falta total de productos'
      }
    ],
    valuesAcknowledgment: { ERM: 0, ACD: 0, RCD: 0, RFP: 0, RFT: 0, WAR: 0 },
    statusesDocumentsStatus: [
      {
        code: 'approved',
        name: 'Documentos emitidos',
        routeQueryValue: '{"cl_status_detail": "Aceptado"}'
      },
      {
        code: 'rejected',
        name: 'Documentos recibidos',
        routeQueryValue: '{"cl_status_detail": "Rechazado"}'
      }
    ],
    valuesDocumentsStatus: { approved: 0, rejected: 0 }
  }),
  computed: mapState({
    // count: state => state.irs.supplierresponsesCount,
    // supplierresponsesList: state => state.irs.supplierresponsesList
  }),
  created () {
    // this.loaderReport = true

    // Promise.all([
    //   this.$store.dispatch('irs/LIST', {
    //     resource: 'irs/sii/supplierresponses/report'
    //   })
    //   .then((response) => {
    //     if (response.data) {
    //       const dataset = response.data.datasets[0].data
    //       const labels = response.data.labels
    //       this.valuesAcknowledgment = Object.fromEntries(labels.map((v, i) => [v, dataset[i]]))
    //     }
    //   }),
    //   this.$store.dispatch('irs/LIST', {
    //     resource: 'irs/sii/documents_status/report'
    //   })
    //   .then((response) => {
    //     if (response.data) {
    //       const dataset = response.data.datasets[0].data
    //       const labels = response.data.labels
    //       this.valuesDocumentsStatus = Object.fromEntries(labels.map((v, i) => [v, dataset[i]]))
    //     }
    //   })
    // ])
    // .finally(() => {
      // setTimeout(() => {
      //   this.loaderReport = false
      // }, 1000)
    // })
  },
  methods: {
    // getList () {
    //   const query = Object.assign({}, this.$route.query, {
    //     expand: 'documents'
    //   })
    //   this.loaderList = true

    //   if (!this.$route.query.code) {
    //     query.code__in = 'RCD,RFP,RFT'
    //   }

    //   this.$store.dispatch('irs/LIST', {
    //     resource: 'irs/sii/supplierresponses',
    //     query: query
    //   })
    //   .finally(() => {
    //     this.loaderList = false
    //   })
    // }
  }
}
</script>